import React from "react";
import { TransactionRuleGroup } from "@common/types/transactionRule";
import { useRuleGroupRemovalMutation } from "@api/ruleGroups.api";
import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";
import { useToaster } from "@design-system/ToastMessages/useToaster";

interface DeleteRuleGroupModalProps {
    ruleGroup: TransactionRuleGroup | null;
    onHide: () => void;
}

export const DeleteRuleGroupModal: React.FC<DeleteRuleGroupModalProps> = ({
    ruleGroup,
    onHide,
}) => {
    const toaster = useToaster();

    const { mutate: deleteRuleGroup } = useRuleGroupRemovalMutation(
        ruleGroup!,
        {
            onSuccess: () => {
                toaster.toast(`Deleted rule group "${ruleGroup?.name}"`);
                onHide();
            },
        },
    );

    if (!ruleGroup) {
        return null;
    }

    return (
        <ConfirmationModal
            title="Delete Rule Group"
            question={
                <>
                    <p>
                        Are you sure you want to delete the rule group "
                        {ruleGroup.name}"?
                    </p>
                    <p>
                        This action cannot be undone. Default rule groups and
                        groups containing rules cannot be deleted.
                    </p>
                </>
            }
            yes="Delete"
            no="Cancel"
            yesBtnVariant="destructive"
            onConfirm={() => deleteRuleGroup()}
            onReject={onHide}
            show
            onHide={onHide}
        />
    );
};
